/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-icon-library {
  display: block;
}
.ux-icon-library__intro-container {
  margin: 0 15px;
}
.ux-icon-library__search-container {
  margin: 25px 15px 0;
  margin-top: 25px;
  max-width: 800px;
}
.ux-icon-library__filter-container {
  margin-top: 25px;
}
.ux-icon-library__tags-container {
  display: flex;
  flex-wrap: nowrap;
  height: 45px;
  -ms-overflow-style: none;
  overflow-x: scroll;
  padding: 10px 15px 5px;
  scrollbar-width: none;
}
.ux-icon-library__tags-container::-webkit-scrollbar {
  display: none;
}
.ux-icon-library__tags-container .ux-tag {
  cursor: pointer;
  margin-bottom: 0;
  white-space: nowrap;
}
.ux-icon-library__filter {
  display: flex;
  flex-direction: column;
  width: 100%;
}
@media (width >= 1024px) {
  .ux-icon-library__filter {
    flex-direction: row;
    justify-content: space-between;
  }
}
.ux-icon-library__filter .ux-dropdown {
  width: 100%;
}
@media (width >= 1024px) {
  .ux-icon-library__filter .ux-dropdown {
    width: calc(33% - 15px);
  }
}
.ux-icon-library__results-details {
  font-size: 20px;
  margin: 10px 15px 0;
}
.ux-icon-library__loading-container {
  margin: 25px 15px 0;
}
.ux-icon-library__results-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 20px;
}

.ux-icon-library-thumbnail {
  box-shadow: 0;
  cursor: pointer;
  height: 205px;
  margin: 0 10px 25px;
  overflow: hidden;
  padding: 20px;
  position: relative;
  transition: box-shadow 250ms ease;
  width: calc(50% - 10px);
}
.ux-icon-library-thumbnail:hover, .ux-icon-library-thumbnail--is-selected {
  box-shadow: 0 7px 22px rgba(19, 19, 19, 0.1);
}
.ux-icon-library-thumbnail__action-buttons {
  display: flex;
  opacity: 0;
  position: absolute;
  right: 15px;
  top: -30px;
  transition: all 250ms ease;
}
.ux-icon-library-thumbnail__container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 115px;
  justify-content: center;
  margin-top: 30px;
  padding-bottom: 35px;
  pointer-events: none;
  position: relative;
  transition: all 250ms ease;
  width: 100%;
}
.ux-icon-library-thumbnail__container ux-icon {
  font-size: 70px;
}
.ux-icon-library-thumbnail__container ux-icon {
  font-size: 70px;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translate(-50%);
  transition: all 250ms ease;
}
.ux-icon-library-thumbnail__name {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  bottom: 0;
  left: 50%;
  position: absolute;
  transform: translate(-50%);
  transition: all 250ms ease;
  white-space: nowrap;
}
.ux-icon-library-thumbnail__weight {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  bottom: -22px;
  color: #727272;
  display: block;
  left: 50%;
  position: absolute;
  text-align: center;
  transform: translate(-50%);
  transition: all 250ms ease;
}
.ux-icon-library-thumbnail__description {
  opacity: 0;
  position: absolute;
  top: 200px;
  transition: all 250ms ease;
  width: calc(100% - 40px);
}
.ux-icon-library-thumbnail:hover .ux-icon-library-thumbnail__description, .selected .ux-icon-library-thumbnail__description {
  opacity: 1;
  top: 110px;
}
.ux-icon-library-thumbnail:hover .ux-icon-library-thumbnail__container, .selected .ux-icon-library-thumbnail__container {
  height: 85px;
  margin-top: 60px;
  padding-bottom: 20px;
  width: 60%;
}
.ux-icon-library-thumbnail:hover .ux-icon-library-thumbnail__container ux-icon, .selected .ux-icon-library-thumbnail__container ux-icon {
  font-size: 50px;
  left: 0;
  transform: translate(0);
}
.ux-icon-library-thumbnail:hover .ux-icon-library-thumbnail__name, .selected .ux-icon-library-thumbnail__name {
  left: 0;
  transform: translate(0);
}
.ux-icon-library-thumbnail:hover .ux-icon-library-thumbnail__weight, .selected .ux-icon-library-thumbnail__weight {
  left: 0;
  transform: translate(0);
}
.ux-icon-library-thumbnail:hover .ux-icon-library-thumbnail__action-buttons, .selected .ux-icon-library-thumbnail__action-buttons {
  opacity: 1;
  top: 20px;
}
@media (width >= 568px) {
  .ux-icon-library-thumbnail {
    width: calc(33.33% - 10px);
  }
}
@media (width >= 768px) {
  .ux-icon-library-thumbnail {
    width: calc(25% - 10px);
  }
}
@media (width >= 1024px) {
  .ux-icon-library-thumbnail {
    width: calc(20% - 20px);
  }
}
@media (width >= 1600px) {
  .ux-icon-library-thumbnail {
    width: calc(15.5% - 10px);
  }
}